export default {
  sections: {
    state: {
      title: 'Tila',
      fields: {
        pickup_visible: {
          label: 'Nouto näkyvissä',
        },
        has_pickup: {
          label: 'Nouto',
        },
      },
    },
    scheduled_orders: {
      title: 'Ajastetut tilaukset',
      fields: {
        has_scheduled_orders: {
          label: 'Sallitaanko asiakkaiden tilata etukäteen tietylle ajalle?',
        },
        min_schedule_ahead_time_pickup: {
          label: 'Vähimmäisaika (minuuteissa) etukäteen <strong>nouto</strong>tilausten ajastamiseen',
          placeholder: '30',
        },
        last_order_gap_pickup: {
          label: 'Viimeinen mahdollinen tilausaika <strong>noudolle</strong> (minuuttia ennen sulkemisaikaa)',
          option: '{{value}} min',
        },
      },
    },
    preparation_time_pickup_orders: {
      title: 'Noutotilausten valmistusaika',
      fields: {
        average_order_preparation_time_min: {
          label: 'Valmistusaika minuuteissa',
          placeholder: '20',
        },
        average_order_preparation_time_max: {
          label: 'asti',
          placeholder: 'Valinnainen',
        },
      },
    },
  },
  buttons: {
    save: 'Tallenna',
  },
  toasts: {
    at_least_one_order_method_required:
      'Vähintään yhden tilaustavan (ajastettu tai heti) on oltava käytössä. Et voi poistaa molempia käytöstä.',
  },
};
